<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="representativeDeliveries.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="representativeDelivery"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :representative-delivery="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="representativeDeliveries.per_page"
        layout="total, prev, pager, next"
        :total="representativeDeliveries.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels, compareTypes } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'descending',
        },
      };
    },
    computed: {
      representativeDeliveries() {
        return this.$store.getters['representativeDelivery/representativeDeliveries'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['representativeDelivery/tableConfig']));
      },
      loading() {
        return this.$store.getters['representativeDelivery/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('representativeDelivery/setFilterString', '');
      this.$store.commit('representativeDelivery/setCurrentPage', this.currentPage);
      this.$store.commit('representativeDelivery/setSorting', this.currentSort);
      await this.$store.dispatch('representativeDelivery/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('representativeDelivery/setCurrentPage', val);
        this.$store.dispatch('representativeDelivery/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('representativeDelivery/setSorting', { prop, order, compareType: compareTypes[prop] || 'string' });
          this.$store.dispatch('representativeDelivery/fetchAll');
        }
      },
    },
  };
</script>
<style>
  .pointer-row {
    cursor: pointer;
  }
</style>
